export interface Category {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
  image: string;
}

export const categories: Category[] = [
  {
    slug: "rexue-maoxian",
    name: "热血冒险",
    desc: "燃烧的斗志与永不言弃的冒险精神，少年踏上改变命运的征途。",
    icon: "ri-fire-line",
    count: 128,
    image:
      "https://readdy.ai/api/search-image?query=Vibrant%20manga%20style%20illustration%20of%20a%20young%20hero%20with%20fiery%20orange%20energy%20aflame%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20red%20palette%2C%20stylized%20anime%20artwork%20with%20bold%20lines%20and%20glowing%20embers%2C%20clean%20cream%20background&width=800&height=500&seq=cat-rexue-01&orientation=landscape",
  },
  {
    slug: "lianai-yanqing",
    name: "恋爱言情",
    desc: "心动与甜蜜交织，细腻描摹青春年华里那些怦然心动的瞬间。",
    icon: "ri-heart-3-line",
    count: 96,
    image:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20manga%20illustration%20of%20a%20couple%20under%20falling%20cherry%20blossoms%2C%20gentle%20warm%20pink%20and%20peach%20tone%2C%20sweet%20youthful%20anime%20artwork%2C%20delicate%20line%20work%2C%20clean%20soft%20cream%20background&width=800&height=500&seq=cat-lianai-01&orientation=landscape",
  },
  {
    slug: "xuanyi-tuili",
    name: "悬疑推理",
    desc: "迷雾重重与层层反转，跟随侦探的脚步抽丝剥茧逼近真相。",
    icon: "ri-search-line",
    count: 74,
    image:
      "https://readdy.ai/api/search-image?query=Moody%20mystery%20manga%20illustration%20of%20a%20detective%20silhouette%20with%20magnifying%20glass%20in%20foggy%20night%20alley%2C%20dramatic%20deep%20amber%20and%20teal%20lighting%2C%20stylized%20anime%20noir%20artwork%2C%20clean%20dark%20background&width=800&height=500&seq=cat-xuanyi-01&orientation=landscape",
  },
  {
    slug: "xuanhuan-xiuxian",
    name: "玄幻修仙",
    desc: "御剑乘风、踏破九霄，踏入气运与机缘交织的修行大道。",
    icon: "ri-sword-line",
    count: 152,
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cultivation%20fantasy%20manga%20illustration%20of%20a%20swordsman%20on%20a%20flying%20sword%20above%20clouds%2C%20warm%20golden%20sunlight%20and%20jade%20mountain%20peaks%2C%20stylized%20xianxia%20anime%20artwork%2C%20clean%20ethereal%20background&width=800&height=500&seq=cat-xuanhuan-01&orientation=landscape",
  },
  {
    slug: "kehuan-jijia",
    name: "科幻机甲",
    desc: "钢铁巨兽与未来科技，在星际战场上书写人类命运的篇章。",
    icon: "ri-rocket-2-line",
    count: 68,
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20mecha%20manga%20illustration%20of%20a%20giant%20robot%20standing%20on%20a%20space%20colony%20at%20dusk%2C%20warm%20orange%20and%20steel%20blue%20tones%2C%20stylized%20sci-fi%20anime%20artwork%2C%20clean%20high%20contrast%20background&width=800&height=500&seq=cat-kehuan-01&orientation=landscape",
  },
  {
    slug: "gaoxiao-richang",
    name: "搞笑日常",
    desc: "爆笑不断与沙雕欢乐，记录平凡生活里最有趣的那些片段。",
    icon: "ri-emotion-laugh-line",
    count: 85,
    image:
      "https://readdy.ai/api/search-image?query=Cheerful%20comedy%20manga%20illustration%20of%20a%20group%20of%20laughing%20cartoon%20characters%20with%20exaggerated%20funny%20expressions%2C%20bright%20warm%20yellow%20and%20orange%20palette%2C%20playful%20stylized%20anime%20artwork%2C%20clean%20cream%20background&width=800&height=500&seq=cat-gaoxiao-01&orientation=landscape",
  },
  {
    slug: "yundong-jingji",
    name: "运动竞技",
    desc: "汗水与荣耀交织，热血少年在赛场上拼尽全力超越极限。",
    icon: "ri-basketball-line",
    count: 57,
    image:
      "https://readdy.ai/api/search-image?query=Dynamic%20sports%20manga%20illustration%20of%20an%20athlete%20dribbling%20a%20basketball%20on%20an%20indoor%20court%2C%20energetic%20warm%20orange%20lighting%20and%20motion%20lines%2C%20stylized%20shonen%20anime%20artwork%2C%20clean%20background&width=800&height=500&seq=cat-yundong-01&orientation=landscape",
  },
  {
    slug: "qihuan-mofa",
    name: "奇幻魔法",
    desc: "神秘魔法与奇妙世界，打开通往异世界的想象之门。",
    icon: "ri-magic-line",
    count: 92,
    image:
      "https://readdy.ai/api/search-image?query=Enchanting%20fantasy%20magic%20manga%20illustration%20of%20a%20mage%20casting%20a%20spell%20with%20glowing%20golden%20rune%20circles%2C%20warm%20amber%20and%20violet%20magic%20sparks%2C%20stylized%20anime%20artwork%2C%20clean%20magical%20background&width=800&height=500&seq=cat-qihuan-01&orientation=landscape",
  },
  {
    slug: "kongbu-lingyi",
    name: "恐怖灵异",
    desc: "阴森诡异与细思极恐，于深夜之中窥探不可名状之物。",
    icon: "ri-ghost-2-line",
    count: 43,
    image:
      "https://readdy.ai/api/search-image?query=Creepy%20horror%20manga%20illustration%20of%20a%20shadowy%20ghost%20figure%20in%20an%20abandoned%20mansion%20corridor%2C%20dim%20candlelight%20with%20deep%20amber%20and%20black%20tones%2C%20stylized%20anime%20horror%20artwork%2C%20clean%20dark%20background&width=800&height=500&seq=cat-kongbu-01&orientation=landscape",
  },
  {
    slug: "xiaoyuan-qingchun",
    name: "校园青春",
    desc: "课桌与操场间的青葱岁月，记录友谊、梦想与成长的足迹。",
    icon: "ri-school-line",
    count: 79,
    image:
      "https://readdy.ai/api/search-image?query=Sunny%20school%20life%20manga%20illustration%20of%20students%20walking%20in%20a%20courtyard%20under%20warm%20afternoon%20light%2C%20soft%20yellow%20and%20amber%20tones%2C%20nostalgic%20stylized%20anime%20artwork%2C%20clean%20bright%20background&width=800&height=500&seq=cat-xiaoyuan-01&orientation=landscape",
  },
];